module.exports = __webpack_public_path__ + "media/contact/hearFromYou-7244c464.jpg";